import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const archiveAddon = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/addons/${_id}/archive`);
};

type UseArchiveAddonOptions = {
  config?: MutationConfig<typeof archiveAddon>;
};

const TOAST_ID = 'archive-addon';

export const useArchiveAddon = ({ config = {} }: UseArchiveAddonOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['addons']);
      toasts.loadingToast.success(TOAST_ID, 'Add-on archived');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Archiving...');
      config.onMutate?.(...args);
    },
    mutationFn: archiveAddon,
  });
};
